import React, {ReactNode, ReactNodeArray} from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import CheckFiberSuccessBlockData from 'app/Models/Content/CheckFiberSuccessBlockData';
import CheckFiberSuccess from './checkFiberSuccess';
export default class CheckFiberSuccessBlock extends EpiComponent<CheckFiberSuccessBlockData> {
  public render(): ReactNode | ReactNodeArray | null {
    return (
      <div className='check-fiber-success-block'>
        <CheckFiberSuccess context={this.getContext()} iContent={this.props.data} />
      </div>
    );
  }
}
